import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-image',
  templateUrl: './view-image.component.html',
  standalone: false,
  styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent implements OnInit {

  @Input() doc: any;
  @Input() fileName: string = 'document';

  constructor(private activeModel: NgbActiveModal) { }

  onClose() {
    const vm = this;
    vm.activeModel.close();
  }

  onDownload() {
    const vm = this;
    if (!vm.doc) return;
    const extension = vm.getFileExtension(vm.doc);
    const link = document.createElement('a');
    link.href = vm.doc;
    link.download = vm.fileName + extension;
    link.click();
  }

  getFileExtension(dataUrl: string): string {
    if (dataUrl.includes('image/png')) return '.png';
    if (dataUrl.includes('application/pdf')) return '.pdf';
    return '.jpg';
  }

  ngOnInit() {
    const vm = this;
    const raw = vm.doc;
    if (raw.startsWith('data:')) {
      return;
    }
    let extension = '.jpg';
    let mime = 'image/jpeg';
    if (raw.startsWith('JVBERi0')) {
      mime = 'application/pdf';
      extension = '.pdf';
    } else if (raw.startsWith('iVBORw0KGgo')) {
      mime = 'image/png';
      extension = '.png';
    } else if (raw.startsWith('R0lGOD')) {
      mime = 'image/gif';
      extension = '.gif';
    } else if (raw.startsWith('UklGR')) {
      mime = 'image/webp';
      extension = '.webp';
    }
    vm.doc = 'data:' + mime + ';base64,' + raw;
    vm.fileName = vm.fileName + extension;
  }

}
